<template>
  <q-dialog
    :visible="isVisible"
    title="处理意见"
    width="350px"
    :innerScroll="false"
    :showFooter="false"
    @close="onCancel"
  >
    <el-form
      ref="editForm"
      :model="form"
      label-width="100px"
      style="height: 100px"
    >
      <el-input
        type="textarea"
        :rows="4"
        v-model.trim="form.opinion"
        placeholder="请输入意见"
        size="small"
        show-word-limit
      ></el-input>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm" :loading="loading">确认</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'EditOpinionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectSpus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        opinion: ''
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = { opinion: '' }
      }
    }
  },
  methods: {
    onCancel() {
      this.form = { opinion: '' }
      this.isVisible = false
    },
    onConfirm() {
      let arr = []
      this.selectSpus.forEach((v) => {
        arr.push({
          productCode: v.productCode,
          editContent: this.form.opinion,
        })
      })
      this.loading = true
      this.$q.productModelDetails
        .productEditor({
          data: JSON.stringify(arr),
        })
        .then((data) => {
          if (data.code === '200') {
            this.$message.success('编辑成功')
            this.$emit('success')
            this.onCancel()
          } else {
            this.$message.error(data.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-footer
  text-align right
  padding 15px 0
</style>
